module.exports = __webpack_public_path__ + "img/scallop-vegetable-saute.176ef1f2.jpg";